import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import type { TourLaunchContext } from '@fordeer/app-tour'
import {
  INVOICE_TOUR_DEVTOOLS_STORE_NAME,
  INVOICE_TOUR_STORE_ACTIONS,
} from './invoiceTourStoreActions'
import type { InvoiceVirtualTourStepDefinition } from '../types/virtualTour.types'

const A = INVOICE_TOUR_STORE_ACTIONS

interface InvoiceTourState {
  activeStep: number | null
  launchContext: TourLaunchContext
  launchId: number
  runningStepDefinitions: InvoiceVirtualTourStepDefinition[] | null
  startTour: (
    stepDefinitions: InvoiceVirtualTourStepDefinition[],
    context?: TourLaunchContext,
  ) => void
  goToStep: (step: number) => void
  stopTour: () => void
}

export const useInvoiceTourStore = create<InvoiceTourState>()(
  devtools(
    (set) => ({
      activeStep: null,
      launchContext: {},
      launchId: 0,
      runningStepDefinitions: null,
      startTour: (stepDefinitions, context) =>
        set(
          (state) => ({
            activeStep: 0,
            launchContext: context ?? {},
            runningStepDefinitions: stepDefinitions,
            launchId: state.launchId + 1,
          }),
          false,
          A.startTour,
        ),
      goToStep: (step) => set({ activeStep: step }, false, A.goToStep),
      stopTour: () =>
        set(
          {
            activeStep: null,
            launchContext: {},
            runningStepDefinitions: null,
          },
          false,
          A.stopTour,
        ),
    }),
    {
      name: INVOICE_TOUR_DEVTOOLS_STORE_NAME,
      enabled: process.env.NODE_ENV !== 'production',
    },
  ),
)
